<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
            {{title}}
          </h3>
        </div>
        <div class="col text-right">
          <div class="row align-items-right">
            <SearchBox v-model="searchTerm" class="search-box"/>
            <base-button
              type="success"
              size="sm"
              icon="ni ni-fat-add"
              @click="$router.push({name: 'add player'})"
            >
              Add Player
            </base-button>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="tableData">
        <template slot="columns">
          <th @click="setSortKey('Name')">
            <i class="fa fa-caret-up" v-if="sortKey === 'Name' && sortAsc"/>
            <i class="fa fa-caret-down" v-if="sortKey === 'Name' && !sortAsc"/>
            Name
          </th>
          <th @click="setSortKey('email')">
            <i class="fa fa-caret-up" v-if="sortKey === 'email' && sortAsc"/>
            <i class="fa fa-caret-down" v-if="sortKey === 'email' && !sortAsc"/>
            Email
          </th>
          <th>Teams</th>
          <th>Flex Leagues</th>
          <th></th>
        </template>

        <template slot-scope="{row}">
          <td scope="row">
            <div class="media align-items-center">
              <a
                href="#"
                class="avatar rounded-circle"
                @click.prevent="$router.push({name: 'edit player', params: {id: row.id}})"
              >
                  <img alt="Image placeholder" :src="getAvatarUrl(row)">
              </a>
              <div class="name" @click="$router.push({name: 'edit player', params: {id: row.id}})">
                <span class="name mb-0 text-sm">{{row.Name}}</span>
              </div>
            </div>
          </td>
          <td>
            {{row.email}}
          </td>

          <td>{{row.teamprofiles ? row.teamprofiles.length : ''}} Team{{row.teamprofiles && row.teamprofiles.length > 1 ? 's' : ''}}</td>
          <td>{{row.profiles ? row.profiles.length : 0}} Flex League{{(row.profiles && row.profiles.length > 1) || (row.profiles && row.profiles.length == 0) ? 's' : ''}}</td>

          <td class="text-right">
            <a
              class="btn btn-sm btn-icon-only text-light"
              role="button"
              @click.prevent="$router.push({name: 'edit player', params: {id: row.id}})"
            >
              <i class="fa fa-edit"></i>
            </a>
          </td>

        </template>

      </base-table>
    </div>

    <div
      class="card-footer d-flex justify-content-end"
      :class="type === 'dark' ? 'bg-transparent': ''"
    >
      <base-pagination
        :total="filteredData.length"
        :perPage="perPage"
        v-model="currentPage" />
    </div>

  </div>
</template>
<script>
import Fuse from 'fuse.js';
import AvatarHelper from '@/helpers/Avatars';
import SearchBox from '@/components/SearchBox.vue';

export default {
  name: 'LeaguesTable',
  props: {
    type: {
      type: String,
    },
    title: String,
    data: {
      type: Array,
    },
    perPage: {
      type: Number,
      default: 10,
    },
  },
  components: {
    SearchBox,
  },
  data() {
    return {
      currentPage: 1,
      sortKey: 'Name',
      sortAsc: true,
      searchTerm: '',
    };
  },
  computed: {
    filteredData() {
      if (this.searchTerm.length > 0) {
        const options = {
          keys: ['Name'],
          threshold: 0.1,
        };

        const fuseSearch = new Fuse(this.data, options);
        const result = fuseSearch.search(this.searchTerm);
        return result
          .sort((a, b) => String(a.Name).localeCompare(b.Name));
      }
      return this.data;
    },
    tableData() {
      const startIndex = this.perPage * (this.currentPage - 1);
      const endIndex = this.perPage * this.currentPage;
      const sortMultiplier = this.sortAsc ? 1 : -1;

      const originalSet = [...this.filteredData];

      originalSet.sort((a, b) => {
        if (this.resolve(this.sortKey, a) > this.resolve(this.sortKey, b)) {
          return 1 * sortMultiplier;
        }
        if (this.resolve(this.sortKey, b) > this.resolve(this.sortKey, a)) {
          return -1 * sortMultiplier;
        }
        return 0;
      });
      return originalSet.slice(startIndex, endIndex);
    },
  },
  watch: {
    searchTerm() {
      if (this.searchTerm.length > 0) {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    getAvatarUrl(user) {
      if (!user || user.avatar === '') {
        return '';
      }
      return AvatarHelper.getAvatar(user);
    },
    setSortKey(key) {
      if (key === this.sortKey) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortKey = key;
      }
    },
    resolve(path, obj = self, separator = '.') {
      const properties = Array.isArray(path) ? path : path.split(separator);
      return properties.reduce((prev, curr) => prev && prev[curr], obj);
    },
  },
};
</script>
<style type="scss" scoped>
  .type{
    text-transform: capitalize;
  }
  .name{
    cursor: pointer;
  }
  .avatar{
    margin-right: 1rem;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  th{
    cursor: pointer;
  }
  .align-items-right {
    justify-content: flex-end;
    margin-right: 0rem;
  }
  .search-box {
    margin-right: 1rem;
  }
</style>
